


const PUBLIC_HTTPS_URL ="https://link.piyanos.com"

const BIO_MAX_LENGTH = 160

const NAME_MAX_LENGTH = 50

const enums ={
    errorCodes:{
        c1:1000,
        c2:1001,
        c3:1002,
        c4:1003,
        c5:1004,
        c6:1005,
        c7:1006,
        c8:1007,
        c9:1008,
        c10:1009,
        c11:1010,
        c12:1011,
        c13:1012,
        c14:1013,
        c15:1014,
        c16:1015,
    },
    formTypes:{
        login:'login',
        forget:'forgot'
    }
}

module.exports={
    PUBLIC_HTTPS_URL,
    BIO_MAX_LENGTH,
    NAME_MAX_LENGTH,
    enums,
    googleConfig:{
        clientId : "529245241781-lur06t1a89tu3rtp9to25b2ejp6v51qo.apps.googleusercontent.com"
    },
    siteConfig:{
        pikey: "604bb0fLdcfee503j6bp4c28607819726310192bda68bdec",
        frontendUrl: 'https://link.piyanos.com',
        company:{
            name:'Piyanos Technology',
            addressLine1:'EVLİYA ÇELEBİ MAH. SADİ KONURALP CAD',
            addressLine2:'BEYOĞLU/ İSTANBUL',
        },
        product:{
            name: 'Link',
            url: 'https://link.piyanos.com',
            support_url:'https://link.piyanos.com',
            logoIcon:'https://pistatic.piyanos.com/uploads/piyanos/icon-128.png',
            whiteLogoIcon:'https://pistatic.piyanos.com/uploads/piyanos/icon-white-128.png',
        }
    },
}